import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ar from './locales/ar.json'
import en from './locales/en.json'

// اللغة الافتراضية عربي، ونقرأ اختيار المستخدم المحفوظ سابقاً على
// هذا الجهاز إن وُجد (نفس فكرة device_selected_db في Dashboard.js —
// كل جهاز يحتفظ باختياره الخاص دون التأثير على أجهزة أخرى)
const savedLanguage = localStorage.getItem('app_language') || 'ar'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en }
    },
    lng: savedLanguage,
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
